/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// wishlist code
// wishlist code on lod
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
  // Only target buttons with both classes
  const buttons = document.querySelectorAll('.wishlist_button.collection_wishlist_button');
  let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];

  buttons.forEach(button => {
    const productTitle = button.dataset.title;

    const isInWishlist = wishlistData.some(item => item.productTitle === productTitle);

    // Set initial state
    if (isInWishlist) {
      button.innerHTML = `
        <svg class="heart-filled" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.3701 11.3445L11.9392 18.0086C11.1528 18.8236 9.84723 18.8236 9.06083 18.0086L2.62994 11.3445C0.456686 9.09246 0.456686 5.44113 2.62994 3.18905C4.8032 0.936982 8.32674 0.936982 10.5 3.18905C12.6733 0.936982 16.1968 0.936982 18.3701 3.18905C20.5433 5.44113 20.5433 9.09246 18.3701 11.3445Z" stroke="#274C1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
        <p class="wishlist_text"> </p>
      `;
    }

    button.addEventListener('click', () => {
      const pdpData = {
        productTitle: button.dataset.title,
        productImg: button.dataset.img,
        productPrice: button.dataset.price,
        productUrl: button.dataset.url,
        productId: button.dataset.id,
         
      };

      const index = wishlistData.findIndex(item => item.productTitle === pdpData.productTitle);

      if (index === -1) {
        wishlistData.push(pdpData);
        button.innerHTML = `
          <svg class="heart-filled" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.3701 11.3445L11.9392 18.0086C11.1528 18.8236 9.84723 18.8236 9.06083 18.0086L2.62994 11.3445C0.456686 9.09246 0.456686 5.44113 2.62994 3.18905C4.8032 0.936982 8.32674 0.936982 10.5 3.18905C12.6733 0.936982 16.1968 0.936982 18.3701 3.18905C20.5433 5.44113 20.5433 9.09246 18.3701 11.3445Z" stroke="#274C1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
          <p class="wishlist_text"> </p>
        `;
      } else {
        wishlistData.splice(index, 1);
        button.innerHTML = `
         <svg class="heart-outline" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.3701 11.3445L11.9392 18.0086C11.1528 18.8236 9.84723 18.8236 9.06083 18.0086L2.62994 11.3445C0.456686 9.09246 0.456686 5.44113 2.62994 3.18905C4.8032 0.936982 8.32674 0.936982 10.5 3.18905C12.6733 0.936982 16.1968 0.936982 18.3701 3.18905C20.5433 5.44113 20.5433 9.09246 18.3701 11.3445Z" stroke="#274C1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
          <p class="wishlist_text"> </p>
        `;
      }

      localStorage.setItem('wishlist', JSON.stringify(wishlistData));
    });
  });


  }, 1000);
});

// Paginaion click wishlist code


$(".pagination__nav").click(function() {

setTimeout(function () {
// Only target buttons with both classes
const buttons = document.querySelectorAll('.wishlist_button.collection_wishlist_button');
let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];

buttons.forEach(button => {
const productTitle = button.dataset.title;

const isInWishlist = wishlistData.some(item => item.productTitle === productTitle);

// Set initial state
if (isInWishlist) {
button.innerHTML = `
<svg class="heart-filled" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3701 11.3445L11.9392 18.0086C11.1528 18.8236 9.84723 18.8236 9.06083 18.0086L2.62994 11.3445C0.456686 9.09246 0.456686 5.44113 2.62994 3.18905C4.8032 0.936982 8.32674 0.936982 10.5 3.18905C12.6733 0.936982 16.1968 0.936982 18.3701 3.18905C20.5433 5.44113 20.5433 9.09246 18.3701 11.3445Z" stroke="#274C1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
<p class="wishlist_text"> </p>
`;
}

button.addEventListener('click', () => {
const pdpData = {
productTitle: button.dataset.title,
productImg: button.dataset.img,
productPrice: button.dataset.price,
productUrl: button.dataset.url,
productId: button.dataset.id,
};

const index = wishlistData.findIndex(item => item.productTitle === pdpData.productTitle);

if (index === -1) {
wishlistData.push(pdpData);
button.innerHTML = `
<svg class="heart-filled" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3701 11.3445L11.9392 18.0086C11.1528 18.8236 9.84723 18.8236 9.06083 18.0086L2.62994 11.3445C0.456686 9.09246 0.456686 5.44113 2.62994 3.18905C4.8032 0.936982 8.32674 0.936982 10.5 3.18905C12.6733 0.936982 16.1968 0.936982 18.3701 3.18905C20.5433 5.44113 20.5433 9.09246 18.3701 11.3445Z" stroke="#274C1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
<p class="wishlist_text"> </p>
`;
} else {
wishlistData.splice(index, 1);
button.innerHTML = `
<svg class="heart-outline" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3701 11.3445L11.9392 18.0086C11.1528 18.8236 9.84723 18.8236 9.06083 18.0086L2.62994 11.3445C0.456686 9.09246 0.456686 5.44113 2.62994 3.18905C4.8032 0.936982 8.32674 0.936982 10.5 3.18905C12.6733 0.936982 16.1968 0.936982 18.3701 3.18905C20.5433 5.44113 20.5433 9.09246 18.3701 11.3445Z" stroke="#274C1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
<p class="wishlist_text"> </p>
`;
}

localStorage.setItem('wishlist', JSON.stringify(wishlistData));
});
});
}, 1000);
})



// End wishlist code
// pasword registration code
document.addEventListener('DOMContentLoaded', function () {
    const password = document.querySelector('#customer\\[password\\]');
    const confirmPassword = document.querySelector('#password_confirmation');
    const submitButton = document.querySelector('button[type="submit"]');
    function validatePasswords() {
    
      if (password.value !== confirmPassword.value) {
        // console.log("Passwords do not match");
        submitButton.disabled = true;
        confirmPassword.setCustomValidity("Passwords do not match");
      } else {
        // console.log("Passwords match");
        submitButton.disabled = false;
        confirmPassword.setCustomValidity("");
      }
    }

    if (confirmPassword) confirmPassword.addEventListener('input', validatePasswords);
    if (password) password.addEventListener('input', validatePasswords);
  });
setInterval(function () {
fetch('/cart.js')
.then(response => response.json())
.then(cart => {
const count = cart.item_count;
$('span.header__cart-count').text(count);
})
    // code for remove disabled class product switch
  $(".product-form__option .block-swatch.block-swatch--disabled").each(function() {
    var val = $(this).attr("data-v");
    if (val === "0" || val === 0) {
        $(this).removeClass("block-swatch--disabled").addClass("block-swatch--sold");
    }
});
}, 1000);
$(".product-block-list__item.product-block-list__item--description button.card__collapsible-button").trigger("click");
$("button.estimate-shipping__toggle").trigger("click")
// $(".faq__group button.faq__question").trigger("click");
$(".cart-recap__note-button").trigger("click");
$("button.value-picker__choice-item.link").click(function() {
setTimeout(function() {
window.location.reload();
}, 500); 
});
$(".custom-needles-template .block-swatch-list.options-grid .block-swatch").click(function(){
var swtch_name=$(this).find(".block-swatch__item").attr("title");
$(this).closest(".product-form__option").find(".product-form__option-name.text--strong .product-form__selected-value").text(swtch_name);
})